<template>
  <div class="viq-welcome">
    <div class="viq-welcome__hero">
      <h1 class="viq-welcome__title">Ask a Question</h1>
      <p class="viq-welcome__subtitle">
        Click a suggestion or type your own question below
      </p>
    </div>

    <div v-if="$slots.input" class="viq-welcome__input">
      <slot name="input" />
    </div>

    <div class="viq-welcome__suggestions">
      <div
        v-for="(item, i) in suggestedCards"
        :key="i"
        class="viq-welcome__card"
        @click="askSuggestion(item.question)"
      >
        <span class="viq-welcome__card-category">{{ item.category }}</span>
        <span class="viq-welcome__card-question">{{ item.question }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqWelcome",
  data() {
    return {
      suggestedCards: [
        {
          category: "Regulatory overview",
          question: "What are the key PSD2 requirements for payment service providers in Europe?",
        },
        {
          category: "Horizon scanning",
          question: "What are the major upcoming regulatory changes for payments in the EU?",
        },
        {
          category: "Licensing",
          question: "What are the licensing requirements for e-money institutions in the UK?",
        },
        {
          category: "AML compliance",
          question: "What are the latest anti-money laundering obligations for payment firms?",
        },
        {
          category: "Cross-border",
          question: "How do open banking regulations differ between the EU and the UK?",
        },
      ],
    };
  },
  computed: {
    ...mapState("Viq", ["mode"]),
  },
  methods: {
    goBack() {
      // Navigate back to initial VIQ state
      this.$store.dispatch("Viq/setMode", "ask");
      this.$store.dispatch("Viq/newConversation");
    },
    askSuggestion(question) {
      this.$store.dispatch("Viq/setMode", "ask");
      this.$store.dispatch("Viq/askQuestion", {
        question,
        conversationId: null,
        lensId: this.$store.state.Viq.activeLens?.id || null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  padding: $viq-space-xl 0;

  &__hero {
    text-align: center;
    margin-bottom: $viq-space-xl;
  }

  &__title {
    font-size: 2rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 $viq-space-sm;
    letter-spacing: -0.01em;
  }

  &__subtitle {
    font-size: $viq-font-md;
    color: $viq-text-secondary;
    margin: 0;
    line-height: 1.5;
  }

  &__input {
    width: 100%;
    max-width: 720px;
    margin: 0 auto $viq-space-lg;
  }

  &__suggestions {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $viq-space-sm;
    max-width: 640px;
    width: 100%;

    // Last item spans full width if odd count
    > :last-child:nth-child(odd) {
      grid-column: 1 / -1;
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    gap: $viq-space-xs;
    padding: $viq-space-md $viq-space-lg;
    background: #ffffff;
    border: 1px solid $viq-border;
    border-radius: $viq-radius-md;
    cursor: pointer;
    transition: background $viq-transition-fast, box-shadow $viq-transition-fast, border-color $viq-transition-fast;

    &:hover {
      background: $viq-bg-secondary;
      box-shadow: $viq-shadow-sm;
      border-color: $viq-accent;
    }
  }

  &__card-category {
    font-size: $viq-font-xs;
    font-weight: 600;
    color: $viq-accent;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  &__card-question {
    font-size: $viq-font-sm;
    color: $viq-text-primary;
    line-height: 1.5;
  }
}
</style>
